import { render } from "./createLession.vue?vue&type=template&id=6c9ebdc6"
import script from "./createLession.vue?vue&type=script&lang=js"
export * from "./createLession.vue?vue&type=script&lang=js"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__